$(function() {

	$(document).on('touchstart', function(event) {
		var oEvent = event.originalEvent,
			jqTarget = $(oEvent.targetTouches[0].target);

	});

});